import ScheduleEntity from "./ScheduleEntity";
import StablishmentEntity from "./StablishmentEntity";
import UserEntity from "./UserEntity";

export enum ShiftStatus {
  PENDING = "pending",
  REJECTED = "rejected",
  NO_CONFIRMED = "noConfirmed",
  WAITING_FIRST_CONFIRMATION = "waitingFirstConfirmation",
  WAITING_SECOND_CONFIRMATION = "waitingSecondConfirmation",
  CONFIRMED_FIRST = "confirmedFirst",
  CONFIRMED_SECOND = "confirmedSecond",
  STARTED = "started",
  READY_TO_FINISH = "readyToFinish",
  FINISHED = "finished",
}

export default class ShiftEntity {
  public id: string;
  public status: ShiftStatus;
  public startDate: Date;
  public endDate: Date;
  public willAttend?: boolean;
  public checkedInAt?: Date;
  public checkedOutAt?: Date;
  public stablishment: StablishmentEntity;
  public user: UserEntity;
  public schedule: ScheduleEntity;
  public scheduleId?: string;
  public turnId: string;

  constructor(data: {
    id: string;
    status: ShiftStatus;
    stablishment: StablishmentEntity;
    user: UserEntity;
    willAttend?: boolean;
    checkedInAt?: Date;
    checkedOutAt?: Date;
    schedule: ScheduleEntity;
    scheduleId?: string;
    startDate: Date;
    endDate: Date;
    turnId: string;

  }) {
    this.id = data.id;
    this.status = data.status;
    this.stablishment = data.stablishment;
    this.user = data.user;
    this.willAttend = data.willAttend;
    this.checkedInAt = data.checkedInAt;
    this.checkedOutAt = data.checkedOutAt;
    this.schedule = data.schedule;
    this.scheduleId = data.scheduleId;
    this.startDate = data.startDate;
    this.endDate = data.endDate;
    this.turnId = data.turnId;
  }

  public copyWith(data: {
    id?: string;
    status?: ShiftStatus;
    stablishment?: StablishmentEntity;
    user?: UserEntity;
    willAttend?: boolean;
    checkedInAt?: Date;
    checkedOutAt?: Date;
    schedule?: ScheduleEntity;
    startDate?: Date;
    scheduleId?: string;
    endDate?: Date;
    turnId?: string;
  }): ShiftEntity {
    return new ShiftEntity({
      id: data.id ?? this.id,
      status: data.status ?? this.status,
      stablishment: data.stablishment ?? this.stablishment,
      user: data.user ?? this.user,
      willAttend: data.willAttend ?? this.willAttend,
      checkedInAt: data.checkedInAt ?? this.checkedInAt,
      checkedOutAt: data.checkedOutAt ?? this.checkedOutAt,
      scheduleId: data.scheduleId ?? this.scheduleId,
      schedule: data.schedule ?? this.schedule,
      startDate: data.startDate ?? this.startDate,
      endDate: data.endDate ?? this.endDate,
      turnId: data.turnId ?? this.turnId,
    });
  }

  public toString(): string {
    return `ShiftEntity { id: ${this.id}, status: ${this.status}, stablishment: ${this.stablishment}, user: ${this.user}, willAttend: ${this.willAttend}, checkedInAt: ${this.checkedInAt}, checkedOutAt: ${this.checkedOutAt}, schedule: ${this.schedule}, startDate: ${this.startDate} }`;
  }
}